import Action from "@/action/Action"
import store from "@/store"
import { sessionState } from "@/state"
import router from "@/router"
import { navigationService } from "@/service"
import { loadStateLocalesAsync, i18n } from "@/plugins/i18n"

class BaseInitFlowAction extends Action {
    route = null
    response = null

    constructor(actionId, route, response) {
        super(actionId)
        this.route = route
        this.response = response
    }

    async invoke() {
        await this.initData()
        return this.next()
    }

    async initData() {
        const response = this.response

        store.commit("testCase/updateTestCases", response.testCases)

        sessionState.session = {
            experienceType: response.experienceType,
            flowType: response.flowType,
            groupId: response.groupId,
            webSessionId: response.webSessionId,
            warnCountdownMillis: response.sessionWarnCountdownMillis,
            timeoutAfterMillis: response.sessionTimeoutMillis,
            properties: response.properties || {},
            extensions: response.extensions || [],
        }

        const state = sessionState?.session?.properties?.state?.toLowerCase()
        if (state) {
            await loadStateLocalesAsync(i18n.locale, state)
        }
    }

    async next() {
        return router.replace(navigationService.getHomeLocation())
    }
}

export default BaseInitFlowAction
